<template>
  <v-app>
    <!-- <v-alert
    class="ma-0"
    type="success"
    v-if="status.success"
  >درخواست با موفقیت ثبت شد!</v-alert>
  <v-alert
    class="ma-0"
    type="error"
    v-if="status.fail"
  >ثبت درخواست با شکست روبرو شد!</v-alert>
  <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
    >
      {{ text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar> -->
    <div class="d-flex flex-column flex-root">
      <div
        class="login login-1 d-flex flex-column flex-md-row flex-column-fluid bg-white"
        :class="{
          'login-signin-on': this.state == 'signin',
          'login-signup-on': this.state == 'signup',
          'login-forgot-on': this.state == 'forgot',
        }"
        id="kt_login"
      >
        <!--begin::Aside-->
        <div
          class="login-aside d-flex flex-column flex-row-auto"
          style="background-color: #001f4beb"
        >
          <div class="d-flex flex-column-auto flex-column pt-lg-10 pt-15">
            <h6
              class="font-weight-bolder mt-lg-35 text-center font-size-h4 font-size-h1-lg"
              style="color: #fff"
            >
              به پنل مدیریت ویردار طب خوش آمدید.
            </h6>
          </div>
          <div
            class="aside-img d-flex flex-row-fluid bgi-no-repeat bgi-position-y-bottom bgi-position-x-center"
            style="background: ~assets/images/Group4.png"
          ></div>
        </div>
        <!--begin::Aside-->
        <!--begin::Content-->
        <div
          class="login-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
        >
          <div class="d-flex flex-column-fluid flex-center">
            <!--begin::Signin-->
            <div class="login-form login-signin">
              <form
                class="form"
                novalidate="novalidate"
                id="kt_login_signin_form"
              >
                <div class="pb-13 pt-lg-0 pt-5">
                  <h3
                    class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                  >
                    خوش آمدید
                  </h3>
                </div>
                <div class="form-group" v-if="!autorize">
                  <label class="font-size-h6 font-weight-bolder text-dark"
                    >شماره موبایل</label
                  >
                  <div
                    id="example-input-group-1"
                    label=""
                    label-for="example-input-1"
                  >
                    <input
                      class="form-control form-control-solid h-auto py-5 px-8 rounded-lg"
                      type="text"
                      name="email"
                      ref="email"
                      v-model="form.email"
                      placeholder="شماره موبایل"
                    />
                  </div>
                </div>
                <div class="form-group" v-if="autorize">
                  <div class="d-flex justify-content-between mt-n5">
                    <label
                      class="font-size-h6 font-weight-bolder text-dark pt-5"
                      >کد تایید</label
                    >
                    <!-- <a
                    class="
                      text-primary
                      font-size-h6 font-weight-bolder
                      text-hover-primary
                      pt-5
                    "
                    id="kt_login_forgot"
                    @click="showForm('forgot')"
                    >رمز خود را فراموش کردید؟</a
                  > -->
                  </div>
                  <div
                    id="example-input-group-2"
                    label=""
                    label-for="example-input-2"
                  >
                    <input
                      class="form-control form-control-solid h-auto py-5 px-8 rounded-lg"
                      name="password"
                      ref="password"
                      placeholder="کد تایید"
                      v-model="form.password"
                      autocomplete="off"
                    />
                  </div>
                </div>
                <div class="pb-lg-0 pb-5 text-center">
                  <button
                    class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-2 my-3"
                    @click="checkVerification"
                    v-if="!autorize"
                    v-bind="load"
                  >
                    تایید
                  </button>
                  <button
                    ref="kt_login_signin_submit"
                    class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-2 my-3"
                    @click="loginHandler"
                    v-else
                  >
                    تایید کد
                  </button>
                </div>
              </form>
            </div>
            <!--end::Signin-->
            <!--begin::Signup-->
            <div class="login-form login-signup">
              <form
                class="form"
                novalidate="novalidate"
                id="kt_login_signup_form"
              >
                <div class="pb-13 pt-lg-0 pt-5">
                  <h3
                    class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                  >
                    بازیابی کلمه عبور
                  </h3>
                  <p class="text-muted font-weight-bold font-size-h4">
                    لطفا فرم زیرا را برای بازیابی پسورد وارد کنید
                  </p>
                </div>
                <div class="form-group">
                  <input
                    class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                    type="text"
                    placeholder="کد تایید"
                    name="fullname"
                    ref="fullname"
                    autocomplete="off"
                    v-model="verificationCode"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                    type="password"
                    placeholder="کلمه عبور"
                    name="password"
                    ref="rpassword"
                    autocomplete="off"
                  />
                </div>
                <div class="form-group">
                  <input
                    class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                    type="password"
                    placeholder="تایید کلمه عبور"
                    name="cpassword"
                    ref="cpassword"
                    autocomplete="off"
                  />
                </div>
                <div class="form-group">
                  <label class="checkbox mb-0">
                    <input type="checkbox" name="agree" />
                    <span class="mr-2"></span>
                    موافقم با
                    <a href="#" class="ml-2">قوانین و شرایط</a>.
                  </label>
                </div>
                <div class="form-group d-flex flex-wrap pb-lg-0 pb-3">
                  <button
                    ref="kt_login_signup_submit"
                    class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
                    style="width: 150px"
                  >
                    ثبت
                  </button>
                  <button
                    type="button"
                    id="kt_login_signup_cancel"
                    class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
                    @click="showForm('signin')"
                  >
                    لغو
                  </button>
                </div>
              </form>
            </div>
            <!--end::Signup-->
            <!--begin::Forgot-->
            <div class="login-form login-forgot">
              <!--begin::Form-->
              <form
                class="form"
                novalidate="novalidate"
                id="kt_login_forgot_form"
                ref="kt_login_forgot_form"
              >
                <div class="pb-13 pt-lg-0 pt-5">
                  <h3
                    class="font-weight-bolder text-dark font-size-h4 font-size-h1-lg"
                  >
                    رمز خود را فراموش کردید؟
                  </h3>
                  <p class="text-muted font-weight-bold font-size-h4">
                    شماره موبایل خود را جهت بازیابی رمز عبور وارد کنید
                  </p>
                </div>
                <div class="form-group">
                  <input
                    class="form-control form-control-solid h-auto py-7 px-6 rounded-lg font-size-h6"
                    type="text"
                    placeholder="موبایل"
                    name="email"
                    autocomplete="off"
                    v-model="emailForget"
                  />
                </div>
                <div class="form-group d-flex flex-wrap pb-lg-0">
                  <button
                    type="button"
                    id="kt_login_forgot_submit"
                    class="btn btn-primary font-weight-bolder font-size-h6 px-8 py-4 my-3 mr-4"
                  >
                    ثبت
                  </button>
                  <button
                    type="button"
                    id="kt_login_forgot_cancel"
                    class="btn btn-light-primary font-weight-bolder font-size-h6 px-8 py-4 my-3"
                    @click="showForm('signin')"
                  >
                    لفو
                  </button>
                </div>
              </form>
            </div>
            <!--end::Forgot-->
          </div>
          <!--begin::Content footer-->
          <div
            class="d-flex justify-content-lg-start justify-content-center align-items-end py-7 py-lg-0"
          >
            <a href="#" class="text-primary font-weight-bolder font-size-h5"
              >قوانین</a
            >
            <a
              href="#"
              class="text-primary ml-10 font-weight-bolder font-size-h5"
              >برنامه ها</a
            >
            <a
              href="#"
              class="text-primary ml-10 font-weight-bolder font-size-h5"
              >ارتباط با ما</a
            >
          </div>
          <!--end::Content footer-->
        </div>
        <!--end::Content-->
      </div>
    </div>
  </v-app>
</template>

<!-- Load login custom page styles -->
<style lang="scss">
@import "@/assets/sass/pages/login/login-1.scss";
</style>

<script>
import formValidation from "@/assets/plugins/formvalidation/dist/es6/core/Core";

// FormValidation plugins
import Trigger from "@/assets/plugins/formvalidation/dist/es6/plugins/Trigger";
import Bootstrap from "@/assets/plugins/formvalidation/dist/es6/plugins/Bootstrap";
import SubmitButton from "@/assets/plugins/formvalidation/dist/es6/plugins/SubmitButton";

import KTUtil from "@/assets/js/components/util";
import { mapGetters, mapState, mapMutations } from "vuex";
import { LOGIN, LOGOUT, REGISTER } from "@/core/services/store/auth.module";
import Swal from "sweetalert2";

import axios from "axios";

export default {
  name: "login-1",
  data() {
    return {
      load: { loading: false },
      state: "signin",
      showSuccessBtn: false,
      autorize: false,
      showFailBtn: false,
      emailForget: "",
      verificationCode: "",
      // Remove this dummy login info
      form: {
        email: "",
        password: "",
      },
    };
  },
  computed: {
    ...mapState({
      errors: (state) => state.auth.errors,
    }),
    ...mapGetters(["currentUser", "tokenValue"]),
    backgroundImage() {
      return (
        process.env.BASE_URL + "media/svg/illustrations/login-visual-1.svg"
      );
    },
  },
  mounted() {
    const signin_form = KTUtil.getById("kt_login_signin_form");
    const signup_form = KTUtil.getById("kt_login_signup_form");
    const forgot_form = KTUtil.getById("kt_login_forgot_form");

    this.fv = formValidation(signin_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "وارد کردن شماره موبایل الزامیست!",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "وارد کردن پسورد الزامیست!",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv1 = formValidation(signup_form, {
      fields: {
        fullname: {
          validators: {
            notEmpty: {
              message: "Full name is required",
            },
          },
        },
        email: {
          validators: {
            notEmpty: {
              message: "وارد کردن شماره موبایل الزامیست!",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
        password: {
          validators: {
            notEmpty: {
              message: "وارد کردن پسورد الزامیست!",
            },
          },
        },
        cpassword: {
          validators: {
            notEmpty: {
              message: "Confirm password is required",
            },
            identical: {
              compare: function () {
                return signup_form.querySelector('[name="password"]').value;
              },
              message: "The password and its confirm are not the same",
            },
          },
        },
        agree: {
          validators: {
            notEmpty: {
              message: "You should agree terms and conditions",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv2 = formValidation(forgot_form, {
      fields: {
        email: {
          validators: {
            notEmpty: {
              message: "وارد کردن شماره موبایل الزامیست!",
            },
            emailAddress: {
              message: "The value is not a valid email address",
            },
          },
        },
      },
      plugins: {
        trigger: new Trigger(),
        submitButton: new SubmitButton(),
        bootstrap: new Bootstrap(),
      },
    });

    this.fv.on("core.form.valid", () => {
      var mobile = this.form.email;
      var password = this.form.password;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      // const submitButton = this.$refs["kt_login_signin_submit"];
      // submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send login request
        this.$store
          .dispatch(LOGIN, { mobile, password })
          // go to which page after successfully login
          .then(() => this.$router.push({ name: "dashboard" }))
          .catch(() => {});

        // submitButton.classList.remove(
        //   "spinner",
        //   "spinner-light",
        //   "spinner-right"
        // );
      }, 2000);
    });

    this.fv.on("core.form.invalid", () => {
      Swal.fire({
        title: "",
        text: "Please, provide correct data!",
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false,
      });
    });

    this.fv1.on("core.form.valid", () => {
      const email = this.$refs.remail.value;
      const password = this.$refs.rpassword.value;

      // clear existing errors
      this.$store.dispatch(LOGOUT);

      // set spinner to submit button
      // const submitButton = this.$refs["kt_login_signup_submit"];
      // submitButton.classList.add("spinner", "spinner-light", "spinner-right");

      // dummy delay
      setTimeout(() => {
        // send register request
        this.$store
          .dispatch(REGISTER, {
            email: email,
            password: password,
          })
          .then(() => this.$router.push({ name: "dashboard" }));

        // submitButton.classList.remove(
        //   "spinner",
        //   "spinner-light",
        //   "spinner-right"
        // );
      }, 2000);
    });

    this.fv1.on("core.form.invalid", () => {
      Swal.fire({
        title: "",
        text: "Please, provide correct data!",
        icon: "error",
        confirmButtonClass: "btn btn-secondary",
        heightAuto: false,
      });
    });
  },
  methods: {
    ...mapMutations(["setToken"]),
    showForm(form) {
      this.state = form;
      var form_name = "kt_login_" + form + "_form";
      KTUtil.animateClass(
        KTUtil.getById(form_name),
        "animate__animated animate__backInUp"
      );
    },
    // verificationCode1() {
    //   axios
    //     .put("http://agriapi.spad-host.ir/api/Account/ResetPassword", {
    //       mobile: this.emailForget,
    //       verificationCode: this.verificationCode,
    //       newPassword: this.$refs.cpassword.value,
    //       confirmPassword: this.$refs.rpassword.value,
    //     })
    // },
    checkVerification() {
      // const submitButton1 = this.$refs["kt_login_signin_submit1"];
      // submitButton1.classList.add("spinner", "spinner-light", "spinner-right");
      this.load.loading = true;
      axios
        .post(
          `https://webapi.virdarteb.com/api/Account/RegisterPhone?mobile=${this.form.email}`
        )
        .then(() => {
          this.autorize = true;
          this.load.loading = false;
          //   submitButton1.classList.remove(
          //   "spinner",
          //   "spinner-light",
          //   "spinner-right"
          // );
        })
        .catch(() => (this.load.loading = false));
    },
    loginHandler() {
      axios
        .post(`https://webapi.virdarteb.com/api/Account/Authorize`, {
          phoneNumber: this.form.email,
          verificationCode: this.form.password,
        })
        .then((response) => {
          sessionStorage.setItem("isAuth", true);
          sessionStorage.setItem("token", response.data.data.token);
          this.$router.push("/dashboard");
        });
    },
  },
};
</script>
<style>
.login.login-1 .login-aside .aside-img {
  background-image: url(../../../../assets/images/Group4.png);
  background-size: contain;
}
</style>
